import { Variant } from '@material-ui/core/styles/createTypography';
import { Theme } from '@material-ui/core';
import { TypographyProps } from '../../../../../ui-kit';

const isValidTypographyVariant = (variant: Variant | TypographyProps['variant']): variant is Variant => {
    return !!(variant && variant !== 'inherit' && variant !== 'srOnly');
};

export const getLabelOffset = (variant: TypographyProps['variant'], theme: Theme) => {
    const lineHeight = isValidTypographyVariant(variant)
        ? theme.typography[variant].lineHeight
        : theme.typography.body1.lineHeight;

    if(!lineHeight){
        return theme.typography.pxToRem(24);
    }

    const offsetInRem = theme.typography.pxToRem(8);

    if(typeof lineHeight === 'string'){
        return `calc(-${lineHeight} - ${offsetInRem})`;
    }

    return `calc(-${lineHeight}rem - ${offsetInRem})`;
};